<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 1.5rem;">客户合同管理</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
							<el-form-item label="开始日期">
								<el-date-picker
										v-model="startTime"
										type="daterange"
										@change="changeIndex"
										value-format="yyyy-MM-dd"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="结束日期">
								<el-date-picker
										v-model="endTime"
										@change="changeIndex"
										type="daterange"
										value-format="yyyy-MM-dd"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<!-- <el-form-item> -->
								<el-button @click="searchData()">查询</el-button>
								<el-button v-if="isAuth('contract:add')" type="primary" @click="addOrUpdate()" icon="el-icon-plus" style="display: inline;">添加</el-button>
								<el-button v-if="isAuth('contract:add')" type="success" @click="HtxxImport()" style="display: inline;">合同批量导入</el-button>
								<el-button v-if="isAuth('contract:importysje')" type="success" style="display: inline;" @click="YsjeBatchIn()" >已收金额导入</el-button>
								<el-button v-if="isAuth('contract:exportysje')" type="success" style="display: inline;" @click="YsjeExport()" >已收金额导出</el-button>
								<el-button v-if="isAuth('contract:delete')"  type="danger" @click="deleteHandle()">批量删除</el-button>
							<!-- </el-form-item> -->

							<el-collapse v-model="activeNames" >
								<el-collapse-item title="更多条件" name="1">
									<el-form-item label="客户">
										<el-select clearable @change="changeIndex" filterable  v-model="searchForm.customerId" placeholder="请选择客户">
											<el-option v-for="item in customerList" :key="item.id" :label="item.customerName" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="状态">
										<el-select v-model="searchForm.status" clearable @change="changeIndex"    placeholder="请选择状态">
											<el-option  :key="0" :label="'未过期'" :value="0"></el-option>
											<el-option  :key="1" :label="'已过期'" :value="1"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="合作属性">
										<el-select clearable v-model="searchForm.cooperationStatus" placeholder="请选择合作属性">
											<el-option :key="0" :label="'长期合作'" :value="'0'"></el-option>
											<el-option :key="1" :label="'临保合作'" :value="'1'"></el-option>
											<el-option :key="2" :label="'结束合作'" :value="'2'"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="金额(元)">
										<el-col :span="11" >
										<el-input-number @change="changeIndex" controls-position="right" v-model="amount[0]" clearable></el-input-number>
										</el-col>
										<el-col class="line"  style="text-align: center" :span="2">-</el-col>
										<el-col :span="11" >
											<el-input-number @change="changeIndex" controls-position="right" v-model="amount[1]" clearable></el-input-number>
										</el-col>
									</el-form-item>
								</el-collapse-item>
							</el-collapse>
						</el-form>
					</el-row>
				</div>

				<el-table
						border
						@selection-change="selectionChangeHandle"
						:header-cell-class-name="handleHeaderClass"
						@sort-change="handleTableSort"
						:data="contractList" v-loading="loading" style="text-align: center; width: 100%;">
					<el-table-column
							type="selection"
							header-align="center"
							align="center"
							width="50">
					</el-table-column>
					<el-table-column prop="customerName" :show-overflow-tooltip="showoverflow" label="单位名称" width="320" >
					</el-table-column>
					<el-table-column  label="开始日期" width="112" prop="start_time" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.startTime?scope.row.startTime.substr(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column  label="结束日期" width="112" prop="end_time" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.endTime?scope.row.endTime.substr(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column  label="合同总金额(元)" prop="amount" width="150" sortable="custom">
						<template slot-scope="scope">
							{{toThousands(scope.row.htzje)}}
						</template>
					</el-table-column>
					<el-table-column  label="开票总金额(元)" prop="bqkpje" width="150" sortable="custom">
					</el-table-column>
					<el-table-column  label="收款总金额(元)" prop="bqskje" width="150" sortable="custom">
					</el-table-column>
					<!-- <el-table-column  label="回款率(%)" prop="hkl" width="112" sortable="custom">
					</el-table-column> -->
					<el-table-column  label="状态" prop="status" width="80"  sortable="custom">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status === 0" type="success">未过期</el-tag>
							<el-tag v-else type="danger">已过期</el-tag>
						</template>
					</el-table-column>
					<el-table-column  label="合作属性" prop="cooperationStatus" width="105">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.cooperationStatus === '0'" type="success">长期合作</el-tag>
							<el-tag v-if="scope.row.cooperationStatus === '1'" type="">临保合作</el-tag>
							<el-tag v-if="scope.row.cooperationStatus === '2'" type="danger">结束合作</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" :render-header="renderHeader">
						<template slot-scope="scope">
							<el-button type="text" size="mini"   @click="showInfo(scope.row)">查看</el-button>
							<el-button type="text" size="mini"   @click="goDetail(scope.row)">详情</el-button>
							<el-button type="text" size="mini" v-if="isAuth('contract:update')"  @click="addOrUpdate(scope.row.id)">修改</el-button>
							<el-button type="text" size="mini"   @click="preview(scope.row)">查看附件</el-button>
							<el-button type="text" size="mini" v-if="isAuth('contract:delete')" @click="deleteHandle(scope.row.id)">删除</el-button>
							<!-- <el-button type="text" size="mini" v-if="isAuth('contract:setgd')" @click="showContractGdxx(scope.row.id)">设置岗点</el-button> -->
							<el-button type="text" size="mini"  v-if="isAuth('contract:setgd')" @click="showContractGdxxInfo(scope.row.id)">查看岗点</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-card>
		</div>
		<el-dialog
				style="text-align: left"
				title="导出"
				:visible.sync="exportVisible"
		>
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
				<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
			</el-checkbox-group>
			<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/contract/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
				<input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
				<input type="hidden" name="fileds" value="" ref="fileds"/>
			</form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
		</el-dialog>
		<add-or-update v-if="customerVisible" ref="customer" @refreshDataList="searchData"></add-or-update>
		<!-- <show-file v-if="showfileVisible" ref="showfile"></show-file> -->
		<el-dialog
  title="提示"
  :visible.sync="showfileVisible"
  width="50%"
  center>
  <el-row :gutter="2" style="height:100%;width:100%">
	<el-col :span="12" style="height:100%;">
			<h3  style="text-align: center;">附件</h3>
			<el-table max-height="250" :show-header="false" :data="fileName" style="width: 100%" >
					<el-table-column prop="name" show-overflow-tooltip/>
					<el-table-column  width="150">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="preview2(scope.row)">预览</el-button><el-button type="primary" size="mini" @click="download(scope.row)">下载</el-button>
      </template>
    </el-table-column>
				</el-table>
              <!-- <div style="border: 1px solid #c0c4cc; min-height: 70px; width: 100%; height: 200px; background-color: white">
                      <el-scrollbar class="scrollbar-wrapper" style="height: 168px;overflow-x: hidden;overflow-y: hidden;">
						<div style="display: flex; line-height: 28px;cursor: pointer;"  v-for="(item, index) in fileName" :key="index"><i class="el-icon-success" style="color:#67c23a;"></i>
							<div style="width:80%;">{{ item.name }}</div>
							<div style="text-align: right;"><el-button size="mini" type="primary" @click="preview2(item)">预览</el-button><el-button type="primary" size="mini" @click="download(item)">下载</el-button></div>
						</div>                       
                      </el-scrollbar>
                    </div> -->
	</el-col>
	<el-col :span="12" style="height:100%;">
		<h3 style="text-align: center;">补充协议附件</h3>
		<el-table max-height="250" :show-header="false" :data="fileName2" style="width: 100%" >
					<el-table-column prop="name" show-overflow-tooltip/>
					<el-table-column  width="150">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="preview2(scope.row)">预览</el-button><el-button type="primary" size="mini" @click="download(scope.row)">下载</el-button>
      </template>
    </el-table-column>
				</el-table>
            <!-- <div style="border: 1px solid #c0c4cc; min-height: 70px; width: 100%; height: 200px; background-color: white">
                <el-scrollbar class="scrollbar-wrapper" style="height: 168px;overflow-x: hidden;overflow-y: hidden;">
                    <div style="display: flex; line-height:  28px;cursor: pointer;" @click="download(item)" v-for="(item, index) in fileName2" :key="index"><i class="el-icon-success" style="color:#67c23a"></i> 
						<div style="width:80%;">{{ item.name }}</div>
						<div style="text-align: right;display: flex;"><el-button size="mini" type="primary" @click="preview2(item)">预览</el-button><el-button type="primary" size="mini" @click="download(item)">下载</el-button></div>

					</div>                       
                      </el-scrollbar>
            </div> -->
	</el-col>
</el-row>
<el-row :gutter="2" style="height:100%;width:100%">
	<el-col :span="12" style="height:100%;">
		<div style="text-align: center;">
			<el-button type="primary" @click="download2(row,'htfj','附件')" style="display: inline;">下载全部</el-button>
        </div>
	</el-col>
	<el-col :span="12" style="height:100%;">
		<div style="text-align: center;">
			<el-button type="primary" @click="download2(row,'htbcfj','补充协议附件')"  style="display: inline;">下载全部</el-button>
        </div>
	</el-col>
</el-row>
  <span slot="footer"  class="dialog-footer">
    <el-button @click="showfileVisible = false">取消</el-button>
  </span>
</el-dialog>
		<con-info  v-if="showInfoVisible" ref="showinfo"></con-info>
		<contract-user v-if="contractUserVisible" ref="contractUser"></contract-user>
		<contract-user-info v-if="contractUserInfoVisible" ref="contractUserInfo" ></contract-user-info>
		<ysje-bacth-in v-if="ysjeBatchVisible" ref="ysjeBatch" @refreshDataList="searchData"></ysje-bacth-in>
		<htxx-bacth-in v-if="htxxBatchVisible" ref="htxxBatch" @refreshDataList="searchData"></htxx-bacth-in>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './contract-add-or-update'
	import Template from "@/template.vue";
	import ShowFile from './contract-showfile'
	import ConInfo from './contract-info'
	import ContractUser from './contract-setuser'
	import ContractUserInfo from './contract-gd'
	import fa from "element-ui/src/locale/lang/fa";
	import YsjeBacthIn from "./ysje-bacth-in";
	import HtxxBacthIn from "./htxx-bacth-in";
	const exportFields=[
		{value:"customerName",name:"客户名称"},
		{value:"startTime",name:"开始时间"},
		{value:"endTime",name:"结束时间"},
		{value:"amount",name:"合同金额"},
		{value:"otherAmount",name:"其他金额"},
		{value:"workPlace",name:"服务地点"},
		{value:"remaek",name:"备注"},
		{value:"workerConfig",name:"人员配置"},
		{value:"status",name:"状态"}
	]
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			AddOrUpdate,
			ShowFile,
			ConInfo,
			ContractUser,
			ContractUserInfo,
			YsjeBacthIn,
			HtxxBacthIn
		}
	})

	export default class contractinfo extends Vue {
		row={}
		customerVisible=false
		ysjeBatchVisible = false
		htxxBatchVisible = false
		currentNo = 1;
		pageSize= 10;
		pageTotal = 0;
		activeNames=[];
		showbmxxVisible = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false
		contractUserVisible =false
		contractUserInfoVisible= false
		showoverflow=false
		searchForm= {
			startTimest: '',
			startTimeed: '',
			endTimest:'',
			endTimeed:'',
			amountst:'',
			amounted:'',
			customerId:'',
			status:'',
			cooperationStatus: ''
		}
		fileList=[]
        fileName=[]
        fileData=[]
        fileList2=[]
        fileName2=[]
        fileData2=[]
		startTime=[]
		endTime=[]
		amount=['','']
		contractList=[]
		loading = false;
		dataListSelections=[];
		sjbm=[]
		orders=[]
		selectBm=''
		isIndeterminate=false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		exportLoding=false
		created() {
			this.getCustomers();
			this.searchData();
		}
		preview2(item){
          var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview2/'+item.saveName+'?access_token='+this.$store.getters.token
          window.open(viewUrl)
      }
		handleSizeChange(val) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val) {
			this.currentNo = val;
			this.searchData();
		}
		getCustomers() {
			this.$http({
				url: '/bjba/customer/findAll/',
				method: 'get'
			}).then(({data}) => {
				this.customerList = data.data
			})
		}
		// 方法一
		 toThousands(num) {
			var result = [ ], counter = 0;
			num = (num || 0).toString().split('');
			for (var i = num.length - 1; i >= 0; i--) {
				counter++;
				result.unshift(num[i]);
				if (!(counter % 3) && i != 0) { result.unshift(','); }
			}
			return result.join('');
		}
		preview(row){
			this.row = row
			// var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
			// window.open(viewUrl)
			this.showfileVisible = true
			// this.$nextTick(() => {
			// 	this.$refs.showfile.init(row)
			// })
			this.$http({
              url: '/bjba/contract/info/'+row.id,
              method: 'get'
            }).then(({data}) => {
              this.fileData  = data.data.attach.htfj
              this.fileData2  = data.data.attach.htbcfj
              this.fileReset()
              this.fileReset2()
            })
		}
		fileReset() {
      this.fileName.splice(0)
      if (this.fileData != undefined && this.fileData.length > 0) {
        this.fileData.forEach((item) => {
          this.fileName.push({
            id: item.id,
			saveName: item.saveName,
            name: item.name
          })
        })
      }
      if (this.fileList != undefined && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          this.fileName.push(item)
        })
      }
    }
    fileReset2() {
      this.fileName2.splice(0)
      if (this.fileData2 != undefined && this.fileData2.length > 0) {
        this.fileData2.forEach((item) => {
          this.fileName2.push({
            id: item.id,
			saveName: item.saveName,
            name: item.name
          })
        })
      }
      if (this.fileList2 != undefined && this.fileList2.length > 0) {
        this.fileList2.forEach((item) => {
          this.fileName2.push(item)
        })
      }
    }
	download(item) {
      if (item.id != undefined) {
        this.axios
          .get('bjba/file/download/' + item.id, { responseType: 'blob' })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.style.display = 'none'
            downloadElement.href = href
            downloadElement.download = item.name // 下载后文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
    download2(row, type,name) {
      this.axios
        .get('bjba/file/download2/' + row.id + '/' + type, { responseType: 'blob' })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.style.display = 'none'
          downloadElement.href = href
          downloadElement.download = name + '.zip' // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href)
        })
        .catch((error) => {
          console.log(error)
        })
    }
		showInfo(row){
			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showinfo.init(row)
			})
		}
		goDetail(row) {
			this.$router.push({
				path:'/bjba/customer/contractDetail',
				query:{id:row.id}
			});
		}
		showContractGdxx(row){

			this.contractUserVisible = true
			this.$nextTick(() => {
				this.$refs.contractUser.init(row)
			})
		}
		showContractGdxxInfo(row){
			this.$request({
				url: `/bjba/contract/findCustomerIds/`+row,
				method: 'get'
			}).then(response => {
				console.log("查询客户id信息：",response);
				if (response.data.code == 200) {
					this.contractUserInfoVisible = true
					this.$nextTick(() => {
						this.$refs.contractUserInfo.init(response.data.data)
					})
				} else {
					this.$message.error("查询失败！")
				}
			}).catch(error => {
				console.log(error)
				this.$message.error("查询失败！")
			});
		}
		// download(id) {
		// 	var downUrl = this.$request.defaults.baseURL+'/bjba/contract/download/'+id+'?type=1&access_token='+this.$store.getters.token
		// 	window.location.href = downUrl
		// }
		changeIndex() {
			this.currentNo = 1
		}
		getParams() {
			if(this.startTime &&this.startTime.length==2){
				this.searchForm.startTimest = this.startTime[0]
				this.searchForm.startTimeed = this.startTime[1]
			} else{
				this.searchForm.startTimest = ''
				this.searchForm.startTimeed = ''
			}
			if(this.endTime && this.endTime.length==2) {
				this.searchForm.endTimest = this.endTime[0]
				this.searchForm.endTimeed = this.endTime[1]
			}else {
				this.searchForm.endTimest = ''
				this.searchForm.endTimeed = ''
			}
			if(this.amount && (this.amount[0] || this.amount[1])) {
				this.searchForm.amountst =this.amount[0]
				this.searchForm.amounted = this.amount[1]
			} else {
				this.searchForm.amountst = ''
				this.searchForm.amounted =''
			}
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.searchForm.orders = encodeURI(JSON.stringify(this.orders));
		}
		searchData() {
			this.getParams()
			this.loading = true;
			this.$request({
					url: '/bjba/contract/findPage',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.contractList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		// 设置列的排序为我们自定义的排序
		handleHeaderClass({ column }) {
			if(!column.multiOrder) column.multiOrder =''
			column.order = column.multiOrder
		}
		handleOrderChange (orderColumn, orderState) {
			let result = this.orders.find(e => e.orderColumn === orderColumn)
			if (result) {
				if(orderState)
					result.orderState = orderState
				else {
					var j =this.orders.indexOf(result);
					if(j !== -1) {
						this.orders.splice(j,1);
					}
				}
			} else {
				this.orders.push({
					orderColumn: orderColumn,
					orderState: orderState
				})
			}
			this.searchData()
		}
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
		handleTableSort({ column }) {
			console.log(column.orderfield)
			column.multiOrder = column.order
			this.handleOrderChange(column.property, column.multiOrder)
		}

		renderHeader (h) {
			return (
					<div class="clearfix">
							<span>操作</span>
							<el-button style="padding:5px;float:right" size="mini"
			onClick={()=>this.showExportDialog()}>导出</el-button></div>
			)
		}

		handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}
		handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}

		showExportDialog() {
			this.exportVisible = true
		}
		exportExcel() {
			var filedLast = this.fields.filter(filed=>{
				return this.fieldList.indexOf(filed.value) !==-1
			})
			if(filedLast && filedLast.length>0) {
				this.getParams();
				this.$refs.fileds.value = JSON.stringify(filedLast)
				this.$refs.exportForm.submit();
			} else {
				this.$message({
					message: '请选择字段',
					type: 'error',
					duration: 1500
				})
				return
			}
		}
		addOrUpdate(val) {

			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(val)
			})

		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/contract/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
		HtxxImport() {
			this.htxxBatchVisible = true;
			this.$nextTick(() => {
				this.$refs.htxxBatch.init(0);
			});
		}
		YsjeBatchIn() {
			this.ysjeBatchVisible = true;
			this.$nextTick(() => {
				this.$refs.ysjeBatch.init(0);
			});
		}
		YsjeExport() {
			this.exportLoding = this.$loading({
				lock: true,
				text: '正在导出中，请耐心等待...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$http({
				url: '/bjba/contract/exportExcelYsje',
				method: 'post',
				params: this.searchForm,
				responseType: 'blob'
			}).then(res => {
				// console.log("返回数据为：",res)
				this.exportLoding.close();
				if (res.data.size != 0) {
					var fileName = '合同已收金额';
					this.downloadWordFile(res,fileName);
				} else {
					this.$message
					({
						message: "导出失败",
						type: 'error',
						duration: 1500
					})
				}
			}).catch(error => {
				console.log("导出失败",error);
				this.exportLoding.close();
				this.$message
					({
						message: "导出失败",
						type: 'error',
						duration: 1500
					})
			})
		}
		downloadWordFile (fileData,fileName) {
            // console.log(fileName+'.xlsx');
            const blob = new Blob([fileData.data], {
                type: fileData.data.type
            })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('A')
            
            a.download = fileName+'.xlsx'  //下载的文件名  自行设置
            a.href = url
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
	}
</script>
<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap{
  overflow-x: hidden;
}
::v-deep .el-table th.gutter{
	display: table-cell!important;
}
	.bcgl {}
</style>
